import React from 'react';
import Button from '@material-ui/core/Button';
import './RepPlaceholder.styl';

export default class RepPlaceholder extends React.Component {
  render() {
    const {onClose} = this.props;

    return (
      <div className={'add-to-plan-coach-placeholder'}>
        <p>You have no coaching plans yet. Ask your manager how to get started.</p>

        <div className={'action-bar'}>
          <Button variant="contained" color="primary" className="ev-button" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    );
  }
}
